import { Box, Typography } from '@mui/material'
import Workflow from './WorkflowItem'
import { IAvailableWorkFlows, IWorkflowItem } from '../interfaces'
import { useTranslation } from 'react-i18next'
import { ReactElement } from 'react'

const AvailableWorkflows = (props: IAvailableWorkFlows): ReactElement => {
    const { availableWorkFlows, hasWriteAccess } = props
    const { t } = useTranslation()

    return (
        <Box
            p={2}
            flex={1}
            sx={{ border: '1px solid rgba(0, 0, 0, 0.2)', maxWidth: '25%' }}
        >
            <Typography variant="h6">{t('availableWorkflows')}</Typography>
            {availableWorkFlows.map((workflow: IWorkflowItem) => (
                <Workflow
                    key={workflow.id}
                    workflow={workflow}
                    hasWriteAccess={hasWriteAccess}
                />
            ))}
        </Box>
    )
}

export default AvailableWorkflows
